/// <amd-module name="Wit/DeliveryPlans/Common/TeamBacklogMap" />

export class TeamBacklogMap<V> {
    private _map: { [teamAndBacklog: string]: V } = {};

    public get(key: string): V | undefined;
    public get(teamId: string, backlogName: string): V | undefined;
    public get(teamId: string, backlogName?: string): V | undefined {
        const key = backlogName ? teamId + backlogName : teamId;
        return this._map[key];
    }

    public set(teamId: string, backlogName: string, value: V): void {
        this._map[teamId + backlogName] = value;
    }

    public get keys() {
        return Object.keys(this._map);
    }
}
